import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Eye, EyeOff, ShieldCheck, ArrowRight, Loader2 } from 'lucide-react';

export default function AdminLogin() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [showPass, setShowPass] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    // Simulate auth — replace with real API call
    await new Promise(r => setTimeout(r, 1200));
    if (form.email === 'admin@sbb.co.id' && form.password === 'admin123') {
      navigate('/admin/dashboard');
    } else {
      setError('Email atau password salah. Coba lagi.');
    }
    setLoading(false);
  };

  return (
    <div className="al-root">
      {/* Background decorations */}
      <div className="al-bg">
        <div className="al-orb al-orb-1" />
        <div className="al-orb al-orb-2" />
        <div className="al-orb al-orb-3" />
        <div className="al-grid" />
      </div>

      <div className="al-split">
        {/* Left panel — branding */}
        <div className="al-left">
          <div className="al-left-inner">
            <div className="al-logo-wrap">
              <div className="al-logo-mark">SB</div>
              <div>
                <div className="al-logo-top">Member of Solusi Bangun Indonesia</div>
                <div className="al-logo-name">Solusi Bangun Beton</div>
              </div>
            </div>

            <div className="al-headline">
              <h1>Platform Admin<br /><span>SBB Digital</span></h1>
              <p>Kelola pesanan, produk, pengiriman, dan laporan operasional dari satu panel terintegrasi.</p>
            </div>

            <div className="al-stats">
              <div className="al-stat">
                <div className="al-stat-n">1.200+</div>
                <div className="al-stat-l">Proyek Dikelola</div>
              </div>
              <div className="al-stat">
                <div className="al-stat-n">48</div>
                <div className="al-stat-l">Kota Aktif</div>
              </div>
              <div className="al-stat">
                <div className="al-stat-n">99.9%</div>
                <div className="al-stat-l">Uptime Platform</div>
              </div>
            </div>

            <div className="al-badges">
              <div className="al-badge"><ShieldCheck size={14} /> ISO 9001 Certified</div>
              <div className="al-badge"><ShieldCheck size={14} /> SNI Compliant</div>
            </div>
          </div>
        </div>

        {/* Right panel — form */}
        <div className="al-right">
          <div className="al-card">
            <div className="al-card-head">
              <div className="al-card-icon"><ShieldCheck size={28} /></div>
              <h2>Masuk ke Dashboard</h2>
              <p>Akses hanya untuk personel berwenang</p>
            </div>

            {error && (
              <div className="al-error">
                <span>⚠</span> {error}
              </div>
            )}

            <form className="al-form" onSubmit={handleSubmit}>
              <div className="al-fg">
                <label htmlFor="email">Email Akun</label>
                <input
                  id="email"
                  type="email"
                  placeholder="admin@sbb.co.id"
                  value={form.email}
                  onChange={e => setForm({ ...form, email: e.target.value })}
                  required
                  autoComplete="email"
                />
              </div>

              <div className="al-fg">
                <div className="al-label-row">
                  <label htmlFor="password">Password</label>
                  <a href="#" className="al-forgot">Lupa password?</a>
                </div>
                <div className="al-pass-wrap">
                  <input
                    id="password"
                    type={showPass ? 'text' : 'password'}
                    placeholder="••••••••••"
                    value={form.password}
                    onChange={e => setForm({ ...form, password: e.target.value })}
                    required
                    autoComplete="current-password"
                  />
                  <button type="button" className="al-eye" onClick={() => setShowPass(!showPass)}>
                    {showPass ? <EyeOff size={16} /> : <Eye size={16} />}
                  </button>
                </div>
              </div>

              <label className="al-remember">
                <input type="checkbox" />
                <span>Ingat saya selama 30 hari</span>
              </label>

              <button type="submit" className="al-submit" disabled={loading}>
                {loading ? (
                  <><Loader2 size={18} className="al-spin" /> Memverifikasi...</>
                ) : (
                  <>Masuk ke Dashboard <ArrowRight size={18} /></>
                )}
              </button>
            </form>

            <div className="al-demo-hint">
              <span>Demo:</span> admin@sbb.co.id / admin123
            </div>

            <div className="al-footer-note">
              &copy; 2025 PT Solusi Bangun Beton · All rights reserved
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
